import { makeStyles } from "@material-ui/core";

export const useStyles = makeStyles((theme) => ({
  form: {
    marginTop: theme.spacing(3),
  },
  input: {
    marginBottom: theme.spacing(3),
  },
  letterStartAdornment: {
    fontWeight: theme.typography.fontWeightBold,
  },
}));
